import React, { useState } from "react";
import { Layout } from "antd";
import {
  CREATOR_LINK,
  CREATOR_NAME,
  PROJECT_NAME,
} from "../../constants/constent";
import LS_SERVICE from "../../utils/localStorage";

function LayoutFooter() {
  const { Footer } = Layout;
  const [companyName] = useState(PROJECT_NAME);

  return (
    <Footer
      style={{
        textAlign: "center",
      }}
    >
      {LS_SERVICE.get("setting")
        ? LS_SERVICE.get("setting")["company_name"] + " "
        : companyName + " "}
      ©{new Date().getFullYear()} Created by{" "}
      <a rel="noreferrer" href={CREATOR_LINK} target="_blank">
        <b>{CREATOR_NAME}</b>
      </a>
    </Footer>
  );
}

export default LayoutFooter;
